import {customElement,LitElementBase,html,repeat,live,query} from "#Shared/Lit";
import {AppointmentFieldModel} from "./AppointmentField.Model";
declare var flatpickr;
declare var rnappointmentVar:any;
@customElement('rn-appointment-field-calendar')
export class AppointmentFieldCalendar extends LitElementBase{

    // @ts-ignore
    @query('input')
    public Input:HTMLInputElement;
    public model:AppointmentFieldModel;
    protected render(): unknown {
        return html`
                <div>
                    <input
                       class='rnInputPrice' placeholder=${this.model.Options.Placeholder} style="width: 100%;" type='text' .value="${live(this.GetInputDateFormat())}" />
                </div>
        `
    }

    protected firstUpdated(_changedProperties: any) {
        super.firstUpdated(_changedProperties);

        this.GenerateDatePicker();
    }



    public GenerateDatePicker() {
        if(this.model.flatPickr!=null)
        {
            this.model.flatPickr.destroy();
            this.model.flatPickr=null;
        }

        let options:any={
            inline:true,
            dateFormat:this.model.Options.Format,
            time_24hr: true,
            onChange: (selectedDates, dateStr, instance)=> {
                if(selectedDates.length==0)
                    this.model.CalendarDate=null;
                else
                    this.model.CalendarDate=selectedDates[0];
                this.model.Refresh();
            },
            onMonthChange: (selectedDates, dateStr, instance)=> {
                let month=instance.currentMonth;
                let year=instance.currentYear;
                this.model.CalendarDate=new Date(year,month,1);
                this.model.LoadAvailableDates();
            },
            onYearChange: (selectedDates, dateStr, instance)=> {
                let month=instance.currentMonth;
                let year=instance.currentYear;
                this.model.CalendarDate=new Date(year,month,1);
                this.model.LoadAvailableDates();
            }
        };
        options.locale={...rnappointmentVar.Locale,firstDayOfWeek:parseFloat(this.model.Options.FirstDayOfWeek.toString())};
        options.defaultDate=this.model.CalendarDate;

        options.disable=[date=>{
            return this.model.AvailableSlots[date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate()]==null;
        }];

        this.model.SetFlatPickr(flatpickr(this.Input,options));
    }

    GetDisplay(): string {
        return 'inline-flex';
    }

    private GetInputDateFormat() {
        if(this.model.CalendarDate==null)
            return '';
        return flatpickr.formatDate(this.model.CalendarDate,this.model.Options.Format);
    }
}
